import type { OutbrainProps } from '../../common/components/AdOps/Outbrain.vue'

export const outbrainPlacementWidgets: Record<string, OutbrainProps> = {}
export const placementsToOutbrainWidgets: Record<string, string> = {}
